import { ExternalProvider } from '../enums/external-provider.enum';
import { SentimentMap } from '../types/sentiment-map.type';

export const sentimentNames: SentimentMap<string> = {
    [ExternalProvider.Microsoft]: 'Microsoft Text Analytics',
    [ExternalProvider.IBM]: 'IBM Sentiment and Context',
    [ExternalProvider.Google]: 'Google Sentiment Analysis',
    [ExternalProvider.Amazon]: 'Amazon Comprehend',
    [ExternalProvider.Stanford]: 'Stanford CoreNLP'
};